import AttachmentListItem from "messaging/attachments/_views/message-attachment-list-item";
import MessageFileInfo from "messaging/attachments/file-info/message-file-info";
import { CorrespondenceEmptyText } from "messaging/correspondence/_views/correspondence-layout";

type SharedFilesListProps = {
  /** The files shared in the pane's conversations, newest first. */
  files: readonly MessageFileInfo[];
  isLoading: boolean;
  /** A search is narrowing the list, so an empty one says nothing matched rather than nothing is shared. */
  isSearching: boolean;
  /** The name of each conversation, by forum id, so a file says where it was shared. */
  forumLabels: ReadonlyMap<string, string>;
};

/**
 * A Correspondence pane's Shared files tab: every file shared in its conversations.
 *
 * The work agreement's chat window and the proposal's comment pane both list their files with this.
 * Each file downloads through the forum it was shared in, so the server checks that forum's readers on
 * every download.
 */
export default function SharedFilesList(props: Readonly<SharedFilesListProps>) {
  const { files, isLoading, isSearching, forumLabels } = props;

  if (files.length === 0) {
    if (isLoading) return null;
    return <CorrespondenceEmptyText>{isSearching ? "No Matching Results" : "No Shared Files"}</CorrespondenceEmptyText>;
  }

  return (
    <>
      {files.map((attachment) => (
        <AttachmentListItem
          key={attachment.id.value}
          attachmentInfo={attachment}
          forumLabel={forumLabels.get(attachment.forumId?.value ?? "")}
        />
      ))}
    </>
  );
}
